<div class="transport-status-editor" [formGroup]="detailsFormGroup">
    <div>
        {{'transport status' | translate:['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status',
        translationService.language]}}
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusAny" name="transportStatusAny">
            {{'any' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.any',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusPlanned" name="transportStatusPlanned">
            {{'planned' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.planned',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusRegistered"
            name="transportStatusRegistered">
            {{'registered' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.registered',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusWaiting" name="transportStatusWaiting">
            {{'waiting' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.waiting',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusRetrieved" name="transportStatusRetrieved">
            {{'retrieved' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.retrieved',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusCompleted" name="transportStatusCompleted">
            {{'completed' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.completed',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusFinished" name="transportStatusFinished">
            {{'finished' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.finished',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusCanceled" name="transportStatusCanceled">
            {{'canceled' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.canceled',
            translationService.language]}}
        </mat-checkbox>
    </div>
    <div>
        <mat-checkbox class="form-checkbox" formControlName="transportStatusPaused" name="transportStatusPaused">
            {{'paused' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.transport-status-editor.transport-status.paused',
            translationService.language]}}
        </mat-checkbox>
    </div>
</div>